import { serializeError } from './helpers';
import { getAccessToken } from './storage';
const redirectToSignIn = () => (window.location.href = '/signin');
const handleRequest = async (url, options) => {
    const accessToken = getAccessToken();
    const headers = { ...options.headers };
    const controller = new AbortController();
    const signal = controller.signal;
    setTimeout(() => {
        controller.abort();
    }, 10000);
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return fetch(`${url}`, {
        ...options,
        headers,
        signal,
    });
};
export const request = async (url, options) => {
    try {
        let res = await handleRequest(url, options);
        if (res.status === 204) {
            throw new Error('No Content');
        }
        if (res.status === 401) {
            res = await handleRequest(url, options);
            if (res.status === 401) {
                redirectToSignIn();
            }
        }
        const result = await res.json();
        if (res.status >= 400) {
            throw new Error(result.error_message);
        }
        return {
            status: res.status,
            data: result,
        };
    }
    catch (error) {
        if (error instanceof Error) {
            throw error;
        }
        throw new Error('Something went wrong');
    }
};
// GET
export const $get = async (url = '', headers) => {
    try {
        const { data } = await request(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        return [data];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//DELETE
export const $delete = async (url = '', headers) => {
    try {
        const { data } = await request(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        return [data];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//POST
export const $post = async (url = '', data = {}, headers) => {
    try {
        const { data: result } = await request(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(data),
        });
        return [result];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//PATCH
export const $patch = async (url = '', data = {}, headers) => {
    try {
        const { data: result } = await request(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(data),
        });
        return [result];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//PUT
export const $put = async (url = '', data = {}, headers) => {
    try {
        const { data: result } = await request(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(data),
        });
        return [result];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//UPLOAD
export const $upload = async (url = '', data, headers) => {
    try {
        const { data: result } = await request(url, {
            method: 'POST',
            headers: { ...headers },
            body: data,
        });
        return [result];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//GGL
export const $gql = async (query = '', variables = {}, headers) => {
    try {
        const { data } = await request('', {
            method: 'POST',
            headers: { ...headers },
            body: JSON.stringify({
                query,
                variables,
            }),
        });
        return [data];
    }
    catch (e) {
        return [null, serializeError(e)];
    }
};
//# sourceMappingURL=api.js.map